module.exports = __webpack_public_path__ + "img/home_web_10.59485595.png";